/* src/app/pages/clubs/clubs.page.scss */
ion-segment {
  background-color: var(--ion-color-mode);
}
ion-thumbnail > img {
  border: solid 1px rgba(255, 255, 255, 0.4);
}
.notification-badge {
  position: absolute;
  z-index: 10;
  left: 4rem;
  top: 1rem;
}
.add-button {
  color: var(--ion-color-text-87);
}
.collection-thumbnail {
  border-radius: 20%;
}
.text-color {
  color: var(--ion-color-text) !important;
}
/*# sourceMappingURL=clubs.page.css.map */
